// FTU element ids
export const FTU_FIRST_YAT_ID = 'FTU_ProfileYatsSection';
export const FTU_YAT_PICKER_ID = 'FTU_ProfileYatPicker';
export const FTU_USERNAME_ID = 'FTU_ProfileUsername';
export const FTU_SHARE_YAT_ID = 'FTU_ProfileShareYat';
export const FTU_EMPTY_ID = 'FTU_ProfileEmptyState';
export const FTU_EMPTY_LINKS = 'FTU_ProfileEmptyLinks';

// Notification Topics

export const NOTIFICATIONS_FTU = 'Onboarding::FTU::Done';
